var map = {
	"./RTX5080_BuyerBot/1.avif": 3779,
	"./RTX5080_BuyerBot/2.avif": 4682,
	"./RTX5080_BuyerBot/3.avif": 1097,
	"./RTX5080_BuyerBot/4.avif": 6200,
	"./bc-brewfactory/1.avif": 959,
	"./bc-brewfactory/2.avif": 6966,
	"./bc-brewfactory/4.avif": 9772,
	"./bc-brewfactory/5.avif": 1275,
	"./bc-brewfactory/6.avif": 9106,
	"./blackjack/1.avif": 1873,
	"./blackjack/2.avif": 3388,
	"./blackjack/3.avif": 9067,
	"./cyberchat/1.avif": 1778,
	"./cyberchat/2.avif": 5195,
	"./cyberchat/3.avif": 8044,
	"./cyberchat/4.avif": 1013,
	"./cyberchat/5.avif": 6342,
	"./homerswebpage/1.avif": 7112,
	"./homerswebpage/2.avif": 3629,
	"./homerswebpage/3.avif": 7102,
	"./lockusb-switch/1.avif": 4673,
	"./lockusb-switch/2.avif": 9132,
	"./lockusb-switch/3.avif": 5659,
	"./tarealba/1.avif": 3729,
	"./tarealba/2.avif": 7916,
	"./tarealba/3.avif": 5067,
	"./tarealba/4.avif": 6214
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7683;